import { CheckoutSessionDetailModule } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetailModule';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_CHECKOUT_SESSION: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_DETAIL,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: '',
      widgets: [
        {
          id: WIDGETS.CHECKOUT_SESSION_PAGE_TITLE,
          roles: [...ALL_CORE_APP_ROLES],
          props: {},
          notShownInRightMenu: true,
        },
      ],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <CheckoutSessionDetailModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
            edit: [...ALL_CORE_APP_ROLES],
          }}
        />
      ),
    },
  ],
};
